import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

import { ref, onMounted, onUnmounted, computed } from '../../adapter-vue';
import TUIChatEngine, {
  TUITranslateService,
  TUIConversationService,
  TUIStore,
  StoreName,
  IMessageModel,
  IConversationModel,
} from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants, ExtensionInfo } from '@tencentcloud/tui-core';
import ChatHeader from './chat-header/index.vue';
import MessageList from './message-list/index.vue';
import MessageInput from './message-input/index.vue';
import MultipleSelectPanel from './mulitple-select-panel/index.vue';
import Forward from './forward/index.vue';
import MessageInputToolbar from './message-input-toolbar/index.vue';
import { isPC, isWeChat, isUniFrameWork } from '../../utils/env';
import { ToolbarDisplayType } from '../../interface';
import TUIChatConfig from './config';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // When deploying a production environment, you do not need to pass in SDKAppID, userID, and userSig through props.
  // eslint-disable-next-line vue/prop-name-casing
  atConversationList: {
    type: Array,
    default: [],
    required: false,
  },
},
  emits: ['closeChat'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const groupID = ref('');
const isGroup = ref(false);
const currentConversationID = ref();
const isMultipleSelectMode = ref(false);
const inputToolbarDisplayType = ref<ToolbarDisplayType>('none');
const messageInputRef = ref();
const messageListRef = ref<InstanceType<typeof MessageList>>();
const groupManageExt = ref<ExtensionInfo | undefined>(undefined);

const y = ref(150);
const changeHeight = ref(false);
const enableAt = ref(true);

const props = __props;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  reset();
});

const isInputToolbarShow = computed<boolean>(() => {
  return isUniFrameWork ? inputToolbarDisplayType.value !== 'none' : true;
});

const reset = () => {
  TUIConversationService.switchConversation('');
};

const closeChat = (conversationID: string) => {
  emits('closeChat', conversationID);
  reset();
};

const insertEmoji = (emojiObj: object) => {
  messageInputRef.value?.insertEmoji(emojiObj);
};
const atSomeone = (atInfo: object) => {
  if (!atInfo) {
    messageInputRef?.value?.addEditorContent('');
    return;
  }
  messageInputRef?.value?.addEditorContent('@' + atInfo?.nick);
};
const handleEditor = (message: IMessageModel, type: string) => {
  if (!message || !type) return;
  switch (type) {
    case 'reference':
      // todo
      break;
    case 'reply':
      // todo
      break;
    case 'reedit':
      if (message?.payload?.text) {
        messageInputRef?.value?.reEdit(message?.payload?.text);
      }
      break;
    default:
      break;
  }
};

const handleGroup = () => {
  groupManageExt.value.listener.onClicked({ groupID: groupID.value });
};

function changeToolbarDisplayType(type: ToolbarDisplayType) {
  inputToolbarDisplayType.value =
    inputToolbarDisplayType.value === type ? 'none' : type;
  if (inputToolbarDisplayType.value !== 'none' && isUniFrameWork) {
    uni.$emit('scroll-to-bottom');
  }
}

function scrollToLatestMessage() {
  messageListRef.value?.scrollToLatestMessage();
}

function toggleMultipleSelectMode(visible?: boolean) {
  isMultipleSelectMode.value =
    visible === undefined ? !isMultipleSelectMode.value : visible;
}

function mergeForwardMessage() {
  messageListRef.value?.mergeForwardMessage();
}

function oneByOneForwardMessage() {
  messageListRef.value?.oneByOneForwardMessage();
}
function clearInput() {
  messageInputRef?.value?.reEdit();
}
function onCurrentConversationUpdate(conversation: IConversationModel) {
  if (currentConversationID.value === conversation?.conversationID) {
    return;
  }

  isMultipleSelectMode.value = false;
  // Each time you switch conversations in TUIChat, you need to initialize chatType
  TUIChatConfig.setChatType(conversation?.type);
  // The TUICustomerServicePlugin plugin determines if the current conversation is a customer service conversation, then sets chatType and activates the conversation.
  TUICore.callService({
    serviceName: TUIConstants.TUICustomerServicePlugin.SERVICE.NAME,
    method:
      TUIConstants.TUICustomerServicePlugin.SERVICE.METHOD.ACTIVE_CONVERSATION,
    params: { conversationID: conversation?.conversationID },
  });
  currentConversationID.value = conversation?.conversationID;
  isGroup.value = conversation?.type === TUIChatEngine.TYPES.CONV_GROUP;
  if (TUICore.getService(TUIConstants.TUICalling.SERVICE.NAME)) {
    // while chat converstaion changed, notify callkit current conversation type, c2c or group
    TUICore.notifyEvent(
      TUIConstants.TUIChat.EVENT.CHAT_STATE_CHANGED,
      TUIConstants.TUIChat.EVENT_SUB_KEY.CHAT_OPENED,
      {
        groupID: conversation?.groupProfile?.groupID,
      }
    );
  }
  if (
    isUniFrameWork &&
    isGroup.value &&
    groupID.value !== conversation?.groupProfile?.groupID
  ) {
    const extList = TUICore.getExtensionList(
      TUIConstants.TUIChat.EXTENSION.CHAT_HEADER.EXT_ID,
      {
        filterManageGroup: !isGroup.value,
      }
    );
    groupManageExt.value = extList[0];
  }
  if (isUniFrameWork && !isGroup.value) {
    groupManageExt.value = undefined;
  }
  groupID.value = conversation?.groupProfile?.groupID;
}
__expose({
  clearInput,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "chat",
    onMousemove: _cache[2] || (_cache[2] = 
      (e) => {
        if (_unref(changeHeight)) {
          y.value = e.view?.outerHeight - e.y - 200;
        }
      }
    ),
    onMouseup: _cache[3] || (_cache[3] = 
      (e) => {
        changeHeight.value = false;
      }
    )
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
    }, [
      (!_unref(currentConversationID))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['tui-chat-default', !_unref(isPC) && 'tui-chat-h5-default'])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : _createCommentVNode("", true),
      (_unref(currentConversationID))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
          }, [
            _createVNode(ChatHeader, {
              class: _normalizeClass([
            'tui-chat-header',
            !_unref(isPC) && 'tui-chat-H5-header',
            _unref(isUniFrameWork) && 'tui-chat-uniapp-header',
          ]),
              onCloseChat: closeChat
            }, null, 8, ["class"]),
            _createVNode(Forward, { onToggleMultipleSelectMode: toggleMultipleSelectMode }),
            _createVNode(MessageList, {
              ref_key: "messageListRef",
              ref: messageListRef,
              class: _normalizeClass([
            'tui-chat-message-list',
            !_unref(isPC) && 'tui-chat-h5-message-list',
          ]),
              isGroup: _unref(isGroup),
              groupID: _unref(groupID),
              isMultipleSelectMode: _unref(isMultipleSelectMode),
              onHandleEditor: handleEditor,
              onCloseInputToolBar: _cache[0] || (_cache[0] = () => changeToolbarDisplayType('none')),
              onToggleMultipleSelectMode: toggleMultipleSelectMode,
              onAtSomeone: atSomeone,
              currentConversationID: _unref(currentConversationID)
            }, null, 8, ["class", "isGroup", "groupID", "isMultipleSelectMode", "currentConversationID"]),
            (_unref(isMultipleSelectMode))
              ? (_openBlock(), _createBlock(MultipleSelectPanel, {
                  key: 0,
                  onOneByOneForwardMessage: oneByOneForwardMessage,
                  onMergeForwardMessage: mergeForwardMessage,
                  onToggleMultipleSelectMode: toggleMultipleSelectMode
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: "border-top",
                    onMousedown: _cache[1] || (_cache[1] = 
              (e) => {
                changeHeight.value = true;
              }
            )
                  }, null, 32),
                  (_unref(isInputToolbarShow))
                    ? (_openBlock(), _createBlock(MessageInputToolbar, {
                        key: 0,
                        class: _normalizeClass([
              'tui-chat-message-input-toolbar',
              !_unref(isPC) && 'tui-chat-h5-message-input-toolbar',
              _unref(isUniFrameWork) && 'tui-chat-uni-message-input-toolbar',
            ]),
                        displayType: _unref(inputToolbarDisplayType),
                        onInsertEmoji: insertEmoji,
                        onChangeToolbarDisplayType: changeToolbarDisplayType,
                        onScrollToLatestMessage: scrollToLatestMessage
                      }, null, 8, ["class", "displayType"]))
                    : _createCommentVNode("", true),
                  _createVNode(MessageInput, {
                    ref_key: "messageInputRef",
                    ref: messageInputRef,
                    class: _normalizeClass([
              'tui-chat-message-input',
              !_unref(isPC) && 'tui-chat-h5-message-input',
              _unref(isUniFrameWork) && 'tui-chat-uni-message-input',
              _unref(isWeChat) && 'tui-chat-wx-message-input',
            ]),
                    isMuted: false,
                    muteText: _unref(TUITranslateService).t('TUIChat.您已被管理员禁言'),
                    placeholder: _unref(TUITranslateService).t('TUIChat.请输入消息'),
                    inputToolbarDisplayType: _unref(inputToolbarDisplayType),
                    onChangeToolbarDisplayType: changeToolbarDisplayType,
                    style: _normalizeStyle(`height: ${_unref(y)}px`),
                    enableAt: _unref(enableAt)
                  }, null, 8, ["class", "muteText", "placeholder", "inputToolbarDisplayType", "style", "enableAt"])
                ], 64))
          ], 2))
        : _createCommentVNode("", true),
      (_unref(isUniFrameWork) && _unref(isGroup) && _unref(groupManageExt))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "group-profile",
            onClick: handleGroup
          }, _toDisplayString(_unref(groupManageExt).text), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 32))
}
}

})